export default __webpack_public_path__ + "locales/children.kk.json";